"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateWidth;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _INumber = _interopRequireDefault(require("../../../common/iObjects/INumber"));

function calculateWidth(_ref) {
  var value = _ref.value,
      end = _ref.end,
      start = _ref.start;

  var _ref2 = value || [],
      _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
      from = _ref3[0],
      to = _ref3[1];

  var scale = null,
      fromNumber = new _INumber["default"](from).toFloat(),
      toNumber = new _INumber["default"](to).toFloat();

  try {
    scale = end - start;
  } catch (e) {
    var _process;

    /* eslint-env node */
    if (((_process = process) === null || _process === void 0 ? void 0 : _process.env.NODE_ENV) !== 'production') {
      window.console.error(e);
    }
  }

  if (!isNaN(fromNumber)) {
    if (fromNumber > end) {
      fromNumber = end;
    } else if (fromNumber < start) {
      fromNumber = start;
    }
  } else {
    fromNumber = start;
  }

  if (!isNaN(toNumber)) {
    if (toNumber > end) {
      toNumber = end;
    } else if (toNumber < start) {
      toNumber = start;
    }
  } else {
    toNumber = start;
  }

  return (toNumber - start) / scale * 100 - (fromNumber - start) / scale * 100;
}